var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwishLogoPrimaryLightBgsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 420 566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: #17191f;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -746,
    y1: 822.6,
    x2: -746.2,
    y2: 823.1,
    gradientTransform: "translate(224261.6 305063) scale(300.3 -370.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef2131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fecf2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -745.4,
    y1: 823,
    x2: -745.9,
    y2: 822.1,
    gradientTransform: "translate(204470.4 247194.2) scale(273.8 -300.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbc52c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f87130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ef52e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661eec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -746,
    y1: 823,
    x2: -745.8,
    y2: 822.5,
    gradientTransform: "translate(224142 305014) scale(300.3 -370.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78f6d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#77d1f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#70a4f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661eec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -746.1,
    y1: 822.3,
    x2: -745.6,
    y2: 823.2,
    gradientTransform: "translate(204377.3 247074.5) scale(273.8 -300.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#536eed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#54c3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#64d769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fecf2c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1-Primary-_x28_Vertical_x29__x2F_Colour_x2F_Light-background_x2F_Swish_x5F_Logo_x5F_Primary_x5F_Light-BG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wordmark_x2F_Swish"
  }, /*#__PURE__*/React.createElement("path", {
    id: "swish_xAE_",
    className: "cls-5",
    d: "M381.4,485.9c0-2,.4-3.9,1.1-5.7.7-1.8,1.8-3.3,3-4.6,1.3-1.3,2.8-2.4,4.5-3.1,1.7-.8,3.6-1.1,5.5-1.1s3.9.4,5.6,1.1c1.7.8,3.3,1.8,4.6,3.1s2.3,2.9,3.1,4.6c.7,1.8,1.1,3.7,1.1,5.7s-.4,3.9-1.1,5.7c-.7,1.8-1.8,3.3-3.1,4.6-1.3,1.3-2.8,2.4-4.6,3.1-1.7.8-3.6,1.1-5.6,1.1s-3.8-.4-5.5-1.1c-1.7-.8-3.2-1.8-4.5-3.1-1.3-1.3-2.3-2.9-3-4.6-.7-1.8-1.1-3.7-1.1-5.7ZM384.3,485.9c0,1.7.3,3.2.9,4.7.6,1.4,1.4,2.7,2.4,3.8,1,1.1,2.2,1.9,3.6,2.5,1.4.6,2.9.9,4.5.9s3.1-.3,4.5-.9c1.4-.6,2.6-1.5,3.6-2.5s1.8-2.3,2.4-3.8c.6-1.4.9-3,.9-4.7s-.3-3.2-.9-4.7c-.6-1.4-1.4-2.7-2.4-3.8-1-1.1-2.2-1.9-3.6-2.5-1.4-.6-2.9-.9-4.5-.9s-3.1.3-4.5.9c-1.4.6-2.6,1.5-3.6,2.5-1,1.1-1.8,2.3-2.4,3.8-.6,1.4-.9,3-.9,4.7ZM390.7,479.6c0-.9.4-1.3,1.3-1.3h4.5c1.4,0,2.6.4,3.4,1.2.9.8,1.3,1.9,1.3,3.4s0,1.1-.3,1.6c-.2.5-.4.8-.7,1.2-.3.3-.6.6-.9.8s-.6.4-1,.4h0c0,.1,0,.2.1.2,0,0,.1.1.2.3,0,.1.1.3.2.4l2.1,4c.2.5.3.8.2,1.1-.1.3-.4.4-.9.4h-.5c-.7,0-1.3-.3-1.6-1l-2.3-4.9h-2.5v4.6c0,.9-.4,1.3-1.2,1.3h-.4c-.8,0-1.2-.4-1.2-1.3v-12.5ZM396,485.4c.8,0,1.4-.2,1.8-.7s.6-1.1.6-1.9-.2-1.4-.6-1.8c-.4-.4-1-.6-1.8-.6h-2.4v5h2.4ZM279.3,495c4.5,0,8.4.6,11.5,1.7,3.2,1.2,5.6,2.2,7.4,3.2,1.5.8,2.4,1.9,2.7,3.2.3,1.3,0,2.7-.7,4.3l-1.3,2.4c-.8,1.6-1.8,2.5-3.1,2.8s-2.7,0-4.4-.7c-1.5-.7-3.3-1.4-5.5-2.2s-4.6-1.1-7.5-1.1-5.2.6-6.8,1.7c-1.6,1.2-2.4,2.8-2.4,4.9s.8,3.4,2.5,4.5c1.6,1.2,3.7,2.2,6.3,3.1,2.5.9,5.2,1.8,8.1,2.9,2.9,1,5.6,2.3,8.1,3.9s4.6,3.6,6.3,6.1c1.6,2.5,2.5,5.6,2.5,9.4s-.6,5.8-1.8,8.3-2.9,4.7-5.2,6.6c-2.3,1.9-5,3.3-8.2,4.4-3.2,1.1-6.7,1.6-10.7,1.6s-10.1-.8-13.9-2.4c-3.8-1.6-6.7-3.1-8.7-4.5-1.5-.9-2.4-2-2.5-3.3-.2-1.3.2-2.7,1.2-4.3l1.6-2.4c1-1.4,2.1-2.2,3.3-2.4s2.6.2,4.3,1.1c1.6.9,3.7,1.9,6.2,3,2.5,1.1,5.5,1.7,9,1.7s5.2-.6,6.9-1.9,2.5-2.9,2.5-5.1-.8-3.3-2.5-4.5c-1.6-1.1-3.7-2.1-6.3-3.1-2.5-.9-5.2-1.9-8.1-3-2.9-1.1-5.6-2.4-8.1-4-2.5-1.6-4.6-3.6-6.3-6.1-1.6-2.5-2.5-5.7-2.5-9.6s.7-6.2,2.1-8.8c1.4-2.6,3.2-4.7,5.6-6.4s5.1-3,8.3-3.9c3.2-.9,6.5-1.3,10.1-1.3ZM81.3,495c4.5,0,8.4.6,11.5,1.7s5.6,2.2,7.4,3.2c1.5.8,2.4,1.9,2.7,3.2.3,1.3,0,2.7-.7,4.3l-1.3,2.4c-.8,1.6-1.8,2.5-3.1,2.8s-2.7,0-4.4-.7c-1.5-.7-3.3-1.4-5.5-2.2-2.1-.8-4.6-1.1-7.5-1.1s-5.2.6-6.8,1.7c-1.6,1.2-2.4,2.8-2.4,4.9s.8,3.4,2.5,4.5c1.6,1.2,3.7,2.2,6.3,3.1,2.5.9,5.2,1.8,8.1,2.9,2.9,1,5.6,2.3,8.1,3.9,2.5,1.6,4.6,3.6,6.3,6.1,1.6,2.5,2.5,5.6,2.5,9.4s-.6,5.8-1.8,8.3-2.9,4.7-5.2,6.6c-2.3,1.9-5,3.3-8.2,4.4-3.2,1.1-6.7,1.6-10.7,1.6s-10.1-.8-13.9-2.4c-3.8-1.6-6.7-3.1-8.7-4.5-1.5-.9-2.4-2-2.5-3.3-.2-1.3.2-2.7,1.2-4.3l1.6-2.4c1-1.4,2.1-2.2,3.3-2.4,1.2-.2,2.6.2,4.3,1.1,1.6.9,3.7,1.9,6.2,3,2.5,1.1,5.5,1.7,9,1.7s5.2-.6,6.9-1.9c1.7-1.2,2.5-2.9,2.5-5.1s-.8-3.3-2.5-4.5c-1.6-1.1-3.7-2.1-6.3-3.1-2.5-.9-5.2-1.9-8.1-3-2.9-1.1-5.6-2.4-8.1-4-2.5-1.6-4.6-3.6-6.3-6.1s-2.5-5.7-2.5-9.6.7-6.2,2.1-8.8c1.4-2.6,3.2-4.7,5.6-6.4s5.1-3,8.3-3.9c3.2-.9,6.5-1.3,10.1-1.3ZM324.1,470c3.7,0,5.6,1.9,5.6,5.6v27.4c0,.9,0,1.7,0,2.3,0,.7-.1,1.3-.2,1.8,0,.6-.1,1.2-.1,1.6h.3c.8-1.6,1.9-3.2,3.4-4.9,1.5-1.6,3.2-3.1,5.2-4.5,2-1.3,4.3-2.4,6.8-3.2,2.5-.8,5.3-1.2,8.2-1.2,7.5,0,13.4,2,17.5,6.1,4.1,4.1,6.2,10.6,6.2,19.7v38c0,3.7-1.9,5.6-5.6,5.6h-5.7c-3.7,0-5.6-1.9-5.6-5.6v-34.6c0-4.2-.7-7.5-2.1-10s-4.3-3.8-8.5-3.8-5.6.6-8.1,1.7c-2.4,1.2-4.5,2.7-6.2,4.7-1.7,2-3,4.4-3.9,7.1-.9,2.7-1.4,5.7-1.4,8.9v25.9c0,3.7-1.9,5.6-5.6,5.6h-5.7c-3.7,0-5.6-1.9-5.6-5.6v-83.2c0-3.7,1.9-5.6,5.6-5.6h5.7ZM235.7,496.6c3.6,0,5.5,1.9,5.5,5.6v56.6c0,3.7-1.8,5.6-5.5,5.6h-5.9c-3.6,0-5.5-1.9-5.5-5.6v-56.6c0-3.7,1.8-5.6,5.5-5.6h5.9ZM122.7,496.6c3.4,0,5.4,1.6,6,4.9l10.9,39.6c.2,1,.3,1.9.5,2.7.1.8.3,1.6.5,2.3.2.8.3,1.6.4,2.3h.3c0-.7.2-1.5.4-2.3.2-.7.3-1.5.5-2.3.1-.8.3-1.7.6-2.7l11.5-39.6c.6-3.2,2.7-4.8,6.1-4.8h5.1c3.3,0,5.3,1.6,6.1,4.8l11.3,39.6c.3,1,.5,1.9.6,2.7.1.8.3,1.6.5,2.3.2.8.3,1.6.4,2.3h.3c0-.7.2-1.5.4-2.3.2-.7.3-1.5.5-2.3.1-.8.3-1.7.6-2.7l10.8-39.6c.8-3.3,2.8-4.9,6.1-4.9h6.1c2,0,3.5.6,4.3,1.7.8,1.2.9,2.7.4,4.5l-17.4,56.9c-.9,3.1-3,4.7-6.3,4.7h-8.9c-3.4,0-5.5-1.6-6.3-4.8l-10.3-33.9c-.3-.9-.5-1.8-.7-2.7s-.4-1.7-.5-2.4c-.2-.8-.3-1.6-.4-2.3h-.3c-.2.7-.4,1.5-.5,2.3-.2.7-.4,1.5-.5,2.4-.2.9-.4,1.8-.7,2.7l-10.3,33.9c-.8,3.2-2.8,4.8-6.1,4.8h-9.2c-3.2,0-5.2-1.6-6.1-4.7l-17.6-56.9c-.5-1.9-.4-3.4.5-4.5.8-1.2,2.2-1.7,4.2-1.7h6.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_x2F_Colour"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Swirl"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-Shape",
    className: "cls-4",
    d: "M119.3,399.2c84.3,40.3,188.3,20.4,251.2-54.5,74.5-88.8,62.9-221.1-25.8-295.5l-59,70.3c69.3,58.2,78.4,161.5,20.2,230.9-46.4,55.3-122.8,73.7-186.5,48.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Light-Cast",
    className: "cls-1",
    d: "M119.3,399.2c84.3,40.3,188.3,20.4,251.2-54.5,7.7-9.2,14.5-18.8,20.3-28.8,9.9-61.7-11.9-126.9-63.2-169.9-13-10.9-27.2-19.8-41.9-26.5,69.3,58.2,78.4,161.5,20.2,230.9-46.4,55.3-122.8,73.7-186.5,48.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left-Swirl"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-shape",
    className: "cls-2",
    d: "M300.3,20.4C216-19.9,111.9,0,49.1,74.9c-74.5,88.8-62.9,221.1,25.8,295.5l59-70.3c-69.3-58.2-78.4-161.5-20.2-230.9C160.2,14,236.6-4.5,300.3,20.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    className: "cls-3",
    d: "M300.3,20.4C216-19.9,111.9,0,49.1,74.9c-7.7,9.2-14.5,18.8-20.3,28.8-9.9,61.7,11.9,126.9,63.2,169.9,13,10.9,27.2,19.8,41.9,26.5-69.3-58.2-78.4-161.5-20.2-230.9C160.2,14,236.6-4.5,300.3,20.4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwishLogoPrimaryLightBgsvg);
export default __webpack_public_path__ + "static/media/Swish Logo Primary Light-BG SVG.ff1a30eb1894556d959279ccf7ec9d5c.svg";
export { ForwardRef as ReactComponent };